import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Vue from 'vue'
import VModal from 'vue-js-modal'
import VueCompositionApi from '@vue/composition-api'
import VCalendar from 'v-calendar'
import VueSweetalert2 from 'vue-sweetalert2'
import Notifications from 'vue-notification'

Vue.use(VueCompositionApi)
Vue.use(VModal)
Vue.use(Notifications)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VCalendar, {
  locale: 'sv-SE',
  input: ['L', 'YYYY-MM-DD', 'YYYY-MM-DD'],
})

const moment = require('moment')
require('moment/locale/sv')

Vue.use(require('vue-moment'), {
  moment,
})

const sweetalertOptions = {
  showCancelButton: true,
  confirmButtonText: 'OK',
  cancelButtonText: 'Avbryt',
  buttonsStyling: false,
}

Vue.use(VueSweetalert2, sweetalertOptions)
